module.exports = __webpack_public_path__ + "static/img/icon5.80186eed.gif";